export enum Role {
    Admin = "Admin",
    User = "User",
    ItTechnician = "ItTechnician",
    Manager = "Manager",
    SalesLeader = "SalesLeader",
    Salesperson = "Salesperson",
    Collector = "Collector",
    CollectionsLeader = "CollectionsLeader",
    BranchManager = "BranchManager",
    LogisticsManager = "LogisticsManager",
    Mortician = "Mortician",
    HRCoordinator="HRCoordinator",
    Accountant = "Accountant",
    Employee = "Employee",
    Client = "Client",
    ClientServiceAgent = "ClientServiceAgent",
    ScreenTechnician = "ScreenTechnician",
    /** Gerencia (seccion de reportes ejecutivos). No es Manager. */
    Management = "Management",
  }

export interface AddRoleRequest {
  username: string;
  roleName: string;
}

export interface RemoveRoleRequest {
  username: string;
  roleName: string;
}
  
